import React from 'react';
import withStaticBuilder from 'StaticBuilder/hocs/StaticBuilderField';
import PropTypes from 'prop-types';
import { RecipientPreviewEmptyStateTextField } from 'SelfServeRecipientBuilder/components';

class TextField extends React.Component {
  constructor(props) {
    super(props);

    this.renderInput = this.renderInput.bind(this);
  }

  renderInput(input) {
    // For the Self Serve Builder Recipient preview modal.
    // For the case where no popup is added, show a tooltip
    // attached to the sample text input by default
    // Needs to be on this level so that it wraps only the text box
    if (this.props.id === 'sample-text-box') {
      return <RecipientPreviewEmptyStateTextField targetElement={input} />;
    }

    return input;
  }

  render() {
    const input = (
      <input
        className="input-large"
        type="text"
        id={this.props.id.toLowerCase()}
        name={this.props.id}
        onChange={this.props.onChange}
        value={this.props.value}
      />
    );

    return this.renderInput(input);
  }
}

TextField.defaultProps = {
  value: '',
};

TextField.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};


export default withStaticBuilder(TextField);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/TextField.jsx